import { render, staticRenderFns } from "./MyActivities.vue?vue&type=template&id=01c0c172&scoped=true"
import script from "./MyActivities.vue?vue&type=script&lang=js"
export * from "./MyActivities.vue?vue&type=script&lang=js"
import style0 from "./MyActivities.vue?vue&type=style&index=0&id=01c0c172&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c0c172",
  null
  
)

export default component.exports